<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.4805 34.1695H25.8196V25.8695H34.1696V22.5304H25.8196V13.8304H22.4805V22.5304H13.8305V25.8695H22.4805V34.1695ZM24.0172 44.7065C21.1438 44.7065 18.452 44.1666 15.9419 43.0868C13.4318 42.007 11.2362 40.5264 9.35486 38.6452C7.47359 36.7639 5.99304 34.5682 4.91321 32.0582C3.83337 29.5483 3.29346 26.8552 3.29346 23.9789C3.29346 21.1026 3.83337 18.4082 4.91321 15.8956C5.99304 13.3831 7.47212 11.194 9.35046 9.3284C11.2288 7.4628 13.4236 5.98587 15.935 4.8976C18.4463 3.80933 21.1409 3.2652 24.0188 3.2652C26.8966 3.2652 29.5929 3.8086 32.1077 4.8954C34.6225 5.9822 36.812 7.45715 38.6762 9.32025C40.5404 11.1833 42.0162 13.3742 43.1037 15.8928C44.1911 18.4115 44.7348 21.1094 44.7348 23.9867C44.7348 26.8627 44.1907 29.5557 43.1024 32.0655C42.0141 34.5752 40.5372 36.7665 38.6716 38.6393C36.806 40.5122 34.6156 41.9916 32.1003 43.0776C29.585 44.1636 26.8906 44.7066 24.0172 44.7066V44.7065ZM24.025 40.7457C28.6663 40.7457 32.6134 39.1168 35.8663 35.859C39.1192 32.6013 40.7457 28.64 40.7457 23.975C40.7457 19.3337 39.1223 15.3866 35.8757 12.1337C32.629 8.8808 28.6658 7.25435 23.9859 7.25435C19.3518 7.25435 15.4047 8.87768 12.1446 12.1243C8.88442 15.371 7.25436 19.3342 7.25436 24.0141C7.25436 28.6482 8.88322 32.5953 12.141 35.8555C15.3987 39.1156 19.36 40.7457 24.025 40.7457Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
